var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "attachment-upload" },
    [
      _c(
        "el-upload",
        {
          staticClass: "upload-demo",
          attrs: {
            action: "#",
            accept:
              ".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.jpg,.jpeg,.png,.gif,.webp",
            multiple: true,
            "show-file-list": false,
            "before-upload": _vm.beforeUpload,
            "http-request": _vm.uploadFile,
            disabled: _vm.uploading,
          },
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary", loading: _vm.uploading },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.uploading ? "上传中..." : "点击上传附件") + " "
              ),
            ]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "upload-hint" }, [
        _vm._v("支持 Word、Excel、PPT、PDF 和图片，单个文件不超过 50 MB"),
      ]),
      _vm.fileList.length > 0
        ? _c(
            "div",
            { staticClass: "attachment-list" },
            _vm._l(_vm.fileList, function (file, index) {
              return _c("div", { key: index, staticClass: "attachment-item" }, [
                _c(
                  "div",
                  {
                    staticClass: "file-info",
                    on: {
                      click: function ($event) {
                        file.status === "success"
                          ? _vm.downloadFile(file)
                          : null
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-document file-icon" }),
                    _c(
                      "span",
                      {
                        staticClass: "file-name",
                        class: { "can-download": file.status === "success" },
                      },
                      [_vm._v(_vm._s(file.name))]
                    ),
                    _c("span", { staticClass: "file-size" }, [
                      _vm._v("(" + _vm._s(_vm.formatFileSize(file.size)) + ")"),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "file-actions" }, [
                  _c("i", {
                    staticClass: "el-icon-close delete-icon",
                    attrs: { title: "删除" },
                    on: {
                      click: function ($event) {
                        return _vm.removeFile(index)
                      },
                    },
                  }),
                ]),
              ])
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }